<template>
<div class="chapter">
<div class="inner_page">
<p class="half_title"><a id="page_xi">KIERKEGAARD, COMMUNICATION,<br/><span class="small">AND</span> VIRTUE</a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_half1.vue?6e70dd58